import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { BaseInstallationComponent } from '../common/base-installation/base-installation.component';
import { BaseFundingComponent } from '../common/base-funding/base-funding.component';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { TunnelStep } from '../model/tunnel-step-type';
import { ConfigurationComponent } from '../../configuration/configuration.component';
import { StorageConfigurationData } from 'src/app/stores/tunnel/model/configuration-data/storage-configuration-data';
import { MODAL } from 'src/app/services/modal.service';
import { StorageComponent } from '../../storage/storage.component';
import { FidelityCardTypeEnum } from '../../../services/fidelity/fidelity';
import { TunnelDataState } from '../../../stores/tunnel/model/tunnel-data-state';
import { BomDataHelper } from '../../../services/helpers/bom-data-helper';

function isBomEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.STORAGE) as
    | StorageConfigurationData
    | undefined;
  return BomDataHelper.isBomUnavailableForProductList(configuration?.bom);
}

export const STORAGE_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: StorageComponent,
    context: CONFIG_CONTEXT.STORAGE,
    title: 'Inspiration',
    modalToOpen: MODAL.WARNING_INSPIRATION,
  },
  {
    component: ConfigurationComponent,
    context: CONFIG_CONTEXT.STORAGE,
    title: 'Conception',
  },
  {
    component: BaseInstallationComponent,
    context: CONFIG_CONTEXT.STORAGE,
    title: 'Pose',
    canPrint: false,
    isDisabled: stateValue => {
      return isBomEmpty(stateValue);
    },
  },
  {
    component: BaseFundingComponent,
    context: CONFIG_CONTEXT.STORAGE,
    title: 'Financement',
    canPrint: false,
    readonlyProductList: true,
    isDisabled: (stateValue, featureSettings) => {
      if (!featureSettings.financement) {
        return isBomEmpty(stateValue);
      }

      return (
        stateValue.currentPricing?.totalWithoutFunding === undefined ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        isBomEmpty(stateValue)
      );
    },
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.STORAGE,
    title: 'Validation',
    canPrint: true,
    readonlyProductList: true,
    modalToOpen: MODAL.FIDELITY_ADVERTISMENT,
    skipModalToOpen: (stateValue, featureSettings) => {
      return (
        !featureSettings.fidelity ||
        (stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE &&
          stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)
      );
    },
    isDisabled: (stateValue, featureSettings) => {
      return (
        (featureSettings.financement
          ? stateValue.currentPricing?.totalWithFunding === undefined ||
            stateValue.currentFunding?.downPayment === undefined
          : stateValue.currentPricing?.totalWithoutFunding === undefined) ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        stateValue.fidelityLoading ||
        (featureSettings.financement && stateValue.fundingLoading) ||
        isBomEmpty(stateValue)
      );
    },
  },
];
